<template>
  <div class="bg-white list-content">
<!--    <div class="map">
      <div id="mapA"></div>
    </div>-->
    <div class="list-box">
      <div class="list-context">
        <div
          class="list"
          v-for="(item, index) in productLists"
          :key="index"
          @click="showMapMarker(index)"
        >
          <div class="top flex-between">
            <p class="title name" v-if="item.customer">
              {{ $lange == "en" ? "Customer Name" : "公司名" }}:
              <span
                class="row-clip"
                :title="item.customer.customerName"
                @click="
                  goPage(
                    '/admin/customer/description',
                    'customerId',
                    item.customerId
                  )
                "
              >
                {{ item.customer.customerName }}
                <b></b>
              </span>
            </p>
            <p class="title name" v-else>
              <span
                class="row-clip"
                @click="goPage('/admin/customer/create')"
                >{{
                  $lange == "en" ? "Customer Name: Null" : "暂无关联客户"
                }}</span
              >
            </p>
            <p class="title job-id">
              JOBID:
              <span
                class="row-clip"
                :title="item.jobId"
                @click="
                  goPage('/admin/product/description', 'productId', item.id)
                "
              >
                {{ item.jobId }}
                <b></b>
              </span>
            </p>
            <p class="label">
              <b>FAS:</b>
              <span
                class="row-clip"
                :title="item.fasId"
                @click.stop="
                  goPage(
                    '/admin/project/description',
                    'fasId',
                    item.fasId,
                    item.customerId
                  )
                "
              >
                {{ item.fasId ? item.fasId : "TBD" }}
                <b></b>
              </span>
            </p>
            <p class="tag" :class="'tag-' + tabClass[item.status]">
              {{ tabText[item.status] }}
            </p>
          </div>
          <div class="bottom flex-between">
            <p class="label">
              <b>{{ $lange == "en" ? "Product Line" : "产品线" }}:</b>
              {{ item.productLine }}
            </p>
            <p class="label">
              <b>{{ $lange == "en" ? "Speed" : "速度" }}:</b>
              {{ item.speed }}
            </p>
            <p class="label">
              <b>{{ $lange == "en" ? "Width" : "幅宽" }}:</b>
              {{ item.breadth }}
            </p>
            <p class="tag"></p>
            <!--   FAS没有的时候跳到项目的创建 -->
          </div>
        </div>
      </div>

      <div class="pagination-block flex-between">
        <el-pagination
          :small="true"
          @current-change="sizeChange"
          :page-size="pageSize"
          layout="prev, pager, next"
          :total="pageTotal"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import BMap from 'BMap'
//import BMapGL from "BMapGL";
export default {
  name: "mapComponent",
  watch: {
    searchParams: {
      handler() {
        this.pageNo = 1;
        this.getData(true);
      },
      deep: true,
    },
  },
  data() {
    return {
      mp: false,
      productLists: [],
      tabClass: ["default", "yellow", "green", "red"],
      tabText: ["新增", "安装", "在保", "过保"],
      clickFlag: true,
      pageSize: 6,
      pageNo: 1,
      pageTotal: 0,
      iconArr: [
        "https://cong-test.oss-cn-shenzhen.aliyuncs.com/LzE1NjY5NjE3MTA3ODRkZWZhdWx0LnBuZw",
        "https://cong-test.oss-cn-shenzhen.aliyuncs.com/LzE1NjY5NjE3NDA5Mjl3YXJuaW5nLnBuZw",
        "https://cong-test.oss-cn-shenzhen.aliyuncs.com/LzE1NjY5NjE3NTQwNTNwcmltYXJ5LnBuZw",
        "https://cong-test.oss-cn-shenzhen.aliyuncs.com/LzE1NjY5NjE3NzI2MjFkYW5nZXIucG5n",
      ],
      iconShadow:
        "https://cong-test.oss-cn-shenzhen.aliyuncs.com/LzE1NjkyMDUxNjIyNTZiYmIucG5n",
    };
  },
  props: {
    searchParams: {
      type: Object,
    },
  },

  methods: {
    getTabText() {
      this.ccRequest
        .do("admin/dict/pageTree", { code: "productStatus" }, "GET")
        .then((res) => {
          let tabText = [];
          if (res.rows && res.rows.length > 0) {
            for (let index = 0; index < res.rows[0].children.length; index++) {
              if (this.$lange == "zh") {
                tabText.push(res.rows[0].children[index].title);
              } else {
                if (
                  res.rows[0].children[index].extraData &&
                  res.rows[0].children[index].extraData[this.$lange]
                ) {
                  tabText.push(
                    res.rows[0].children[index].extraData[this.$lange]
                  );
                }else {
                tabText.push(res.rows[0].children[index].title);

                }
              }
            }
            this.tabText=tabText
          }
        });
    },
    showMapMarker(index) {
      if (!this.clickFlag) {
        this.$message({
          type: "warning",
          message: "请勿频繁点击",
        });
        return false;
      }
      for (let i in this.productLists) {
        this.productLists[i].visible = false;
      }
      this.productLists[index].visible = true;
      this.clickFlag = false;
      //this.initMap(index);
      setTimeout(() => {
        this.clickFlag = true;
      }, 500);
    },
    sizeChange(res) {
      this.pageNo = res;
      this.getData(true);
    },
    getData(params = false) {
      this.productLists = [];
      let data = params ? this.searchParams : {}; //未知作用，暂时注释
      data.pageSize = this.pageSize;
      data.pageNo = this.pageNo;
      console.log(data, "pData");
      this.ccRequest.do("admin/fsb/product/query", data, "GET").then((res) => {
        if (res.rows && res.rows.length > 0) {
          for (let i in res.rows) {
            res.rows[i].visible = false;
          }
          this.productLists = res.rows;
          this.pageTotal = res.total;
          //this.initMap();
        }
      });
    },
    goPage(path, type = false, id = false, customerId = false) {
      let query = {};
      if (type == "fasId" && !id) {
        if (!customerId) {
          return this.$message({
            type: "warning",
            message: "请先创建客户",
          });
        }
        path = "/admin/project/create";
      }
      if (type == "customerId" && !id) {
        path = "/admin/customer/create";
      }
      query[type] = id;

      this.$router.push({
        path: path,
        query: query,
      });
    },
    // initMap(index = false){
    //     var mp = new BMap.Map("mapA", {minZoom:4,maxZoom:8});
    //     if(index !== false){
    //         mp.centerAndZoom(new BMap.Point(this.productLists[index].longitude,this.productLists[index].latitude), 10);
    //         mp.clearOverlays();
    //     } else {
    //         mp.centerAndZoom(new BMap.Point(116.3964,39.9093), 10);
    //     }
    //
    //
    //     mp.setMapStyleV2({
    //         // styleId: '3d71dc5a4ce6222d3396801dee06622d'
    //         styleId: 'ed8fa8c9f0ceb2fa4de29748f687c5ab'
    //     });
    //     mp.enableScrollWheelZoom(true);
    //     for(let i in this.productLists){
    //         let item = this.productLists[i];
    //         if(item.visible){
    //             let latitude = item.latitude; //纬度
    //             let longitude = item.longitude; //经度
    //             let point = new BMap.Point(longitude, latitude);
    //             var myIcon = new BMap.Icon(this.iconArr[item.status], new BMap.Size(42, 42), {
    //                 imageSize: new BMap.Size(40,40), //调节icon的大小
    //                 anchor: new BMap.Size(31, 41), //设置偏移
    //                 // 设置图片偏移。
    //                 // 当您需要从一幅较大的图片中截取某部分作为标注图标时，您
    //                 // 需要指定大图的偏移位置，此做法与css sprites技术类似。
    //                 imageOffset: new BMap.Size(0, 0),   // 设置图片偏移
    //
    //             });
    //             // myIcon.setImageSize(new BMap.Size(40,40))
    //             // 创建标注对象并添加到地图
    //             var marker = new BMap.Marker(point, {icon: myIcon});
    //             // marker.setAnimation(BMAP_ANIMATION_BOUNCE);
    //             mp.addOverlay(marker);
    //         }
    //
    //     }
    //
    // },
    /*initMap(index) {
      let mp = this.mp;
      if (index !== false) {
        mp.centerAndZoom(
          new BMapGL.Point(
            this.productLists[index].longitude,
            this.productLists[index].latitude
          ),
          6
        );
        mp.clearOverlays();
      } else {
        mp.centerAndZoom(new BMapGL.Point(118.5, 27.5), 6);
      }

      // mp.setMapStyleV2({
      //     // styleId: '3d71dc5a4ce6222d3396801dee06622d'
      //     styleId: 'ed8fa8c9f0ceb2fa4de29748f687c5ab'
      // });
      mp.enableScrollWheelZoom(true);
      for (let i in this.productLists) {
        let item = this.productLists[i];
        if (item.visible) {
          let latitude = item.latitude; //纬度
          let longitude = item.longitude; //经度
          let point = new BMapGL.Point(longitude, latitude);
          var myIcon = new BMapGL.Icon(
            this.iconArr[item.status],
            new BMapGL.Size(42, 42),
            {
              imageSize: new BMapGL.Size(40, 40), //调节icon的大小
              anchor: new BMapGL.Size(31, 41), //设置偏移
              // 设置图片偏移。
              // 当您需要从一幅较大的图片中截取某部分作为标注图标时，您
              // 需要指定大图的偏移位置，此做法与css sprites技术类似。
              imageOffset: new BMapGL.Size(0, 0), // 设置图片偏移
            }
          );
          // myIcon.setImageSize(new BMap.Size(40,40))
          // 创建标注对象并添加到地图
          var marker = new BMapGL.Marker(point, { icon: myIcon });
          // marker.setAnimation(BMAP_ANIMATION_BOUNCE);
          mp.addOverlay(marker);
        }
      }
    },*/
    // checkLanguage() {
    //   if (this.$lange == "en") {
    //     this.tabText = [
    //       "New",
    //       "Installation",
    //       "Under warranty",
    //       "Out of warranty",
    //     ];
    //   }
    // },
  },
  mounted() {
    // this.checkLanguage();
    this.getData();
    /*var mp = new BMapGL.Map("mapA", { minZoom: 4, maxZoom: 8 });
    mp.centerAndZoom(new BMapGL.Point(118.5, 27.5), 5.5);
    mp.enableScrollWheelZoom(false);
    mp.setMapType(BMAP_EARTH_MAP);
    this.mp = mp;*/
    this.getTabText();
  },
};
</script>

<style scoped lang="scss">
.list-content {
  flex: 1;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  .map {
    width: 55%;
    height: 671px;
    overflow: hidden;
    box-sizing: border-box;
    border-right: 1px solid #e4e4e4;
  }
  .list-box {
    flex: 1;
    padding: 20px 10px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .list-context {
      height: 580px;
      overflow: auto;
    }
    .list {
      width: 100%;
      cursor: pointer;
      border-radius: 5px;
      border: 1px solid #f2f2f2;
      box-sizing: border-box;
      padding: 10px 15px;
      &:not(:first-child) {
        margin-top: 15px;
      }
      &:hover {
        background: #f2f2f2;
      }
      & > div {
        display: flex;
        justify-content: space-between;
        p > span {
          display: inline-block;
          position: relative;
          padding-bottom: 2px;
          transition: all 0.3s;
          font-weight: normal;
          b {
            transition: all 0.3s;
            position: absolute;
            width: 100%;
            height: 1px;
            left: 0;
            bottom: 0;
            right: 0;
            margin: auto;
            background: #6f6f6f;
          }

          &:hover {
            color: #1ab394;
            > b {
              width: 50%;
              background: #1ab394;
            }
          }
        }
      }
      .top {
        > p:not(:last-child) {
          flex: 0 25%;
        }
        .job-id {
          font-weight: bold;
        }
        .name {
          font-weight: bold;
        }
        .row-clip {
          transform: translateY(5px);
          max-width: 120px;
        }
      }
      .tag {
        border: 1px solid #e4e4e4;
        border-radius: 5px;
        padding: 2px 5px;
        box-sizing: border-box;
        font-size: 12px;
      }
      .bottom {
        margin-top: 20px;
        color: #9c9c9c;
        font-size: 14px;
        .label:not(:last-child) {
          flex: 0 25%;
        }
        .tag {
          width: 36px;
          opacity: 0;
        }
      }
    }
    .pagination-block {
      margin-top: 25px;
      justify-content: flex-end;
    }
  }
}
#mapA {
  height: 100%;
  min-height: 800px;
}
.bg-white {
  /*padding: 20px;*/
  background: #ffffff;
}
.tag-yellow {
  background: #e98f36;
  color: #ffffff;
}
.tag-green {
  background: #4b7902;
  color: #ffffff;
}
.tag-default {
  background: #f2f2f2;
  color: #282828;
}
.tag-red {
  background: #a30014;
  color: #ffffff;
}
</style>
